import styled from 'styled-components';

import { MpText } from 'shared/ui/MpText';

export const UnauthorizedModalStyled = styled.div`
	padding: 0 8px;
`;

export const ModalHeadingStyled = styled.h1`
	margin: 0;
	padding-bottom: 8px;
	font-size: 20px;
`;

export const ModalTextStyled = styled(MpText)`
	padding: 8px 0;
`;
